import axios, { endpoints } from 'src/utils/axios';
import {
  serializeCredential,
  ensurePasskeySupport,
  getPasskeyErrorMessage,
  prepareAssertionOptions,
} from 'src/utils/webauthn';

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async (params) => {
  try {
    const response = await axios.post(endpoints.auth.signIn, params);
    return response.data;
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

export const completeSecondFactor = async (params) =>
  (await axios.post(endpoints.auth.secondFactor, params)).data;

export const getAuthenticationOptions = async () => (await axios.get(endpoints.auth.options)).data;

export const createCaptcha = async () => (await axios.post(endpoints.auth.captcha)).data;

export const signInWithPasskey = async (identifier) => {
  ensurePasskeySupport();
  const start = (await axios.post(endpoints.auth.passkeyOptions, { identifier })).data;
  let credential;
  try {
    credential = await navigator.credentials.get({
      publicKey: prepareAssertionOptions(start.options),
    });
  } catch (error) {
    throw new Error(getPasskeyErrorMessage(error, 'ورود با کلید عبور'));
  }
  if (!credential) throw new Error('انتخاب کلید عبور لغو شد.');
  return (
    await axios.post(endpoints.auth.passkeyComplete, {
      challengeId: start.challengeId,
      credential: serializeCredential(credential),
    })
  ).data;
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async (params) => {
  try {
    const res = await axios.post(endpoints.auth.signUp, params);
    return res.data;
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    await axios.post(endpoints.auth.signOut);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};

export const verifyOtp = async (params) => (await axios.post(endpoints.auth.verify, params)).data;

export const resendRegistrationOtp = async (params) =>
  (await axios.post(endpoints.auth.resendVerification, params)).data;

export const requestPasswordReset = async (params) =>
  (await axios.post(endpoints.auth.forgotPassword, params)).data;

export const resetPassword = async (params) => axios.post(endpoints.auth.resetPassword, params);
